import { Check, Copy, Share2 } from "lucide-react";
import { toast } from "sonner";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const targets = (text, url) => [
  { key: "whatsapp", label: "WhatsApp", href: `https://wa.me/?text=${encodeURIComponent(`${text} ${url}`)}` },
  { key: "x", label: "X / Twitter", href: `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}` },
  { key: "facebook", label: "Facebook", href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}` },
  { key: "telegram", label: "Telegram", href: `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}` },
];

export const ShareMenu = ({ text, url = window.location.href, testId = "share", label, className = "" }) => {
  const copy = async () => {
    await navigator.clipboard.writeText(`${text} ${url}`);
    toast.success("Lien copié — colle-le dans ta story Instagram ou où tu veux !", { icon: <Check className="w-4 h-4" /> });
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid={`${testId}-trigger`}
        aria-label="Partager"
        className={`inline-flex items-center justify-center gap-2 outline-none transition-colors duration-200 ${className}`}
      >
        <Share2 className="w-4 h-4" /> {label}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="rounded-none bg-black border-white/10 min-w-[200px] z-[120]">
        {targets(text, url).map((t) => (
          <DropdownMenuItem key={t.key} asChild className="rounded-none focus:bg-primary focus:text-white cursor-pointer">
            <a href={t.href} target="_blank" rel="noreferrer" data-testid={`${testId}-${t.key}`} className="uppercase text-xs font-bold tracking-[0.15em] py-3">
              {t.label}
            </a>
          </DropdownMenuItem>
        ))}
        <DropdownMenuItem onSelect={copy} data-testid={`${testId}-copy`} className="rounded-none focus:bg-primary focus:text-white cursor-pointer uppercase text-xs font-bold tracking-[0.15em] py-3 gap-2">
          <Copy className="w-4 h-4" /> Copier (Instagram…)
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
